export default {
  meta: {
    title: '老店优化'
  },
};
